"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var basic_data_format_1 = require("./basic-data-format");
exports.ImmutableBasicDataFormat = basic_data_format_1.ImmutableBasicDataFormat;
var mc_other_format_1 = require("./mc-other-format");
exports.ImmutableMCOtherFormat = mc_other_format_1.ImmutableMCOtherFormat;
var zip_format_1 = require("./zip-format");
exports.ImmutableZipExtensionFormat = zip_format_1.ImmutableZipExtensionFormat;
var form_constants_1 = require("../../form-constants");
/**
 * converts a non-immutable definition of a required definition, and converts it into an immutable definition
 * @param definition the non-immutable definition
 */
function convertToImmutable(definition) {
    if (!definition)
        return null;
    switch (definition.type) {
        case form_constants_1.dataFormatType.NONE: return new basic_data_format_1.ImmutableBasicDataFormat(definition);
        case form_constants_1.dataFormatType.ZIP_EXTENSION: return new zip_format_1.ImmutableZipExtensionFormat(definition);
        case form_constants_1.dataFormatType.MULTIPLE_CHOICE_OTHER: return new mc_other_format_1.ImmutableMCOtherFormat(definition);
        default: return null;
    }
}
exports.convertToImmutable = convertToImmutable;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-elements/data-format/index.js
// module id = 1136
// module chunks = 0